import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
	ConfirmationPrompt, EditTask
} from '../';

import * as Actions from 'actions';
import moment from 'moment';
import { Link } from 'react-router';

class TasksList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			show_delete_modal : false,
			selected_task_id : '',
			editing_task : false,
		};

		this.handleClickCheckbox = this.handleClickCheckbox.bind(this);
		this.handleClickDeleteTask = this.handleClickDeleteTask.bind(this);
		this.handleDeleteTask = this.handleDeleteTask.bind(this);
	}

	handleClickCheckbox(event) {
		let task = this.props.tasks.find(t => t._id === event.target.id);
		let data = {
			_id : task._id,
			completed : !task.completed
		};

  	this.props.sendSocketEmit(data, 'task-complete');
	}

	handleClickDeleteTask(id) {
		this.setState({show_delete_modal : true});
		this.setState({selected_task_id : id});
	}

	handleDeleteTask() {
		this.props.sendSocketEmit({task_id : this.state.selected_task_id}, 'task-delete');
		this.setState({show_delete_modal : false});
		this.setState({selected_task_id : ''});
	}

	render() {

		let {tasks} = this.props;
		let modal_message;
		let even_class_name;
		let due_date_class_name;

		if(tasks && tasks[0] && tasks[0].completed) {
			modal_message =
				'Are you sure you want to delete this task? \n' +
				'This action can not be undone.';
		}
		else {
			modal_message =
				'Are you sure you want to delete this task? \n' +
				'This task is still active.';
		}

		return (
			<div className='tasks-list-container'>
				<ConfirmationPrompt
					handleCancelPrompt={() => {this.setState({show_delete_modal : false})}}
					handleConfirmPrompt={this.handleDeleteTask}
					show_condition={this.state.show_delete_modal}
					title='Delete Task?'
					body={modal_message}
					confirm_button_text='Delete'
					cancel_button_text='Cancel'
				/>
				<div className='form-group'>
					<ul className='widget-todo-list'>
						{tasks.map((task, index) => {
							if((index % 2) !== 0) {
								even_class_name = 'even_task';
							}
							else {
								even_class_name = '';
							}

							let task_date = new Date(task.due_date)

							if(!task.completed && task_date <= Date.now()) {
								due_date_class_name = 'late-task'
							}
							else {
								due_date_class_name = '';
							}

							let printed_date = moment(task_date).format('MMM DD, YYYY h:mm a');

							return (
								<li key={index}>
									<div className='task-list-checkbox-container'>
										<div className='checkbox-custom checkbox-default'>
											<input
												type='checkbox'
												id={task._id}
												onChange={this.handleClickCheckbox}
												checked={task.completed}
												className='task-list-checkbox'
											/>
											<label className="todo-label">
												{task.client ? (
													<Link to={`client/${task.client._id}`} className="btn btn-inline btn-primary btn-xs mr-sm" style={{}}><i className="fa fa-user"></i> {task.client.name || '(no name)'}</Link>
												) : ''}
												<span style={{fontWeight: 'bold'}}>{task.text}</span> <br />
												<span className="text-muted pt-sm" style={{ display:'block', color: !task.completed && task_date > Date.now() ? 'red' : undefined, fontSize:'.8em'}}><i className="fa fa-calendar"></i> {printed_date}
													{task.assigned_by && typeof task.assigned_by === 'object' ? task.assigned_by._id == this.props.connection.user._id? <span> - <i className="fa fa-user"></i> You created this task.</span> : <span> - <i className="fa fa-user"></i> Assigned By {task.assigned_by.name.first ? `${ task.assigned_by.name.first } ${task.assigned_by.name.last}` : assigned_by.username}</span> : ''}
													{task.assigned_to && typeof task.assigned_to === 'object' ? task.assigned_to._id == this.props.connection.user._id? <span> - <i className="fa fa-dot-circle-o"></i> This task is assigned to you.</span> : <span>
														<i className="fa fa-dot-circle-o"></i> Assigned to {task.assigned_to.name.first ? `${task.assigned_to.name.first} ${task.assigned_to.name.last}` : assigned_to.username}
													</span> : ''}
												</span>
											</label>
										</div>
									</div>
									<div className="todo-actions"><a className="todo-remove" href='#' onClick={e => {
										e.preventDefault();
										this.handleClickDeleteTask(task._id);
									}}><i className="fa fa-times"></i></a></div>
								</li>
							)
						})}
					</ul>
				</div>
			</div>
		);
	}
}

export default connect(state => ({connection: state.connection}), Actions)(TasksList)



// WEBPACK FOOTER //
// ./src/browser/components/tasks/tasksList.js